"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles_1 = require("@material-ui/core/styles");
const colors_1 = require("../../assets/jss/colors");
const styles = (theme) => (0, styles_1.createStyles)({
    container: {
        [theme.breakpoints.up('lg')]: {
            marginLeft: 0
        },
        [theme.breakpoints.down('lg')]: {
            marginLeft: theme.spacing()
        },
        [theme.breakpoints.down('md')]: {
            marginLeft: theme.spacing(2)
        }
    },
    drawsLink: {
        display: 'flex'
    },
    header: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    gridRow: {
        marginTop: theme.spacing(2)
    },
    subtitle: {
        display: 'flex',
        flexDirection: 'row',
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2)
    },
    noWrapText: {
        flexWrap: 'nowrap'
    },
    detailContainer: {
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(2)
    },
    alert: {
        marginLeft: theme.spacing(2)
    },
    imageCard: {
        position: 'relative',
        marginBottom: theme.spacing(2),
        [theme.breakpoints.up('sm')]: {
            width: 350,
            height: 350,
            marginRight: theme.spacing(2)
        },
        [theme.breakpoints.only('xs')]: {
            width: 328
        }
    },
    previewText: {
        position: 'absolute',
        top: '59%',
        left: '35%',
        fontSize: '20px',
        border: 'none',
        color: 'white',
        fontWeight: 500,
        textShadow: '0 0 10px rgba(0,0,0,0.8)'
    },
    playIcon: {
        position: 'absolute',
        top: '40%',
        left: '42%',
        height: '70px!important',
        width: '70px!important',
        cursor: 'pointer',
        transition: 'transform .5s ease-in-out',
        '&:hover': {
            transform: 'scale(1.3)'
        }
    },
    parentDiv: { position: 'relative' },
    overlay40: {
        filter: 'brightness(0.6)'
    },
    detailCardWrapper: {
        paddingRight: theme.spacing(2),
        paddingBottom: theme.spacing(2),
        [theme.breakpoints.down('xs')]: {
            paddingBottom: theme.spacing(4)
        }
    },
    image: {
        [theme.breakpoints.up('sm')]: {
            height: 350,
            width: 350
        },
        [theme.breakpoints.only('xs')]: {
            height: 328,
            width: 328
        }
    },
    imageStyle: {
        height: 350,
        width: 350
    },
    rules: {
        [theme.breakpoints.down('xs')]: {
            display: 'flex',
            justifyContent: 'center'
        }
    },
    rulesLink: {
        display: 'flex',
        textDecoration: 'none'
    },
    prizesLink: {
        display: 'flex',
        textDecoration: 'none',
        marginTop: theme.spacing(2)
    },
    prizeSummary: {
        marginBottom: theme.spacing(2)
    },
    prizes: {
        marginTop: theme.spacing(2)
    },
    additionalInfo: {
        marginTop: theme.spacing(2)
    },
    prizeDescriptionLink: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        textDecoration: 'none',
        textTransform: 'uppercase'
    },
    winnersBtn: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    enterTicketButton: {
        marginTop: theme.spacing(4)
    },
    eligibleGames: {
        marginTop: theme.spacing(4)
    },
    allEligibleGamesCard: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignContent: 'stretch',
        alignItems: 'center',
        height: 432,
        [theme.breakpoints.down('lg')]: {
            height: 372
        },
        [theme.breakpoints.down('md')]: {
            height: 290
        },
        [theme.breakpoints.down('xs')]: {
            height: 432
        }
    },
    entriesBox: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        backgroundColor: theme.palette.common.white,
        borderRadius: theme.spacing(),
        border: `1px solid ${theme.palette.primary.main}`,
        [theme.breakpoints.down('xs')]: {
            marginTop: theme.spacing(3),
            marginBottom: theme.spacing(3)
        }
    },
    entriesButton: {
        borderRadius: 5,
        paddingLeft: 16,
        paddingRight: 8,
        marginRight: 16
    },
    entriesGrid: {
        backgroundColor: '#e6edf3',
        padding: '16px 0 4px 0',
        borderRadius: '8px 0 0 8px'
    },
    body1High: Object.assign(Object.assign({}, theme.typography.body1), { color: theme.palette.text.primary, fontWeight: 600 }),
    spacing: {
        padding: 16
    },
    lastCell: {},
    middleCell: {
        [theme.breakpoints.down('xs')]: {
            padding: '4px 24px 4px 24px'
        }
    },
    body2High: Object.assign(Object.assign({}, theme.typography.body2), { color: theme.palette.text.primary }),
    firstCell: {
        minWidth: 108,
        [theme.breakpoints.down('xs')]: {
            minWidth: 40,
            maxWidth: 40
        }
    },
    table: {
        marginBottom: theme.spacing(2)
    },
    tableRow: {
        '&.Mui-focusVisible': {
            boxShadow: `0 0 0px 2px white, 0 0 0 6px ${colors_1.default.themeColors.boxShadowColor.hex()}`
        }
    },
    formLabel: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1)
    },
    progressiveContent: {
        display: 'flex',
        flexDirection: 'row'
    },
    progressiveInnerContent: {
        display: 'flex',
        flexDirection: 'column',
        padding: theme.spacing(2)
    },
    legendContainer: {
        display: 'flex',
        justifyContent: 'flex-end'
    },
    spacingContainer: {
        width: '50%'
    },
    activeFirstCell: {
        borderLeft: `2px solid ${theme.palette.primary.main.lighten(0.25)}`
    },
    activeDrawCell: {
        borderTop: `2px solid ${theme.palette.primary.main.lighten(0.25)}`,
        borderBottom: `2px solid ${theme.palette.primary.main.lighten(0.25)}`
    },
    activeLastCell: {
        borderRight: `2px solid ${theme.palette.primary.main.lighten(0.25)}`
    },
    activeLegendText: {
        paddingRight: theme.spacing(),
        paddingLeft: theme.spacing()
    },
    endedLegendText: {
        paddingLeft: theme.spacing()
    },
    legendImg: {
        width: '22px',
        height: '22px'
    },
    drawEndCornerIcon: {
        top: 0,
        left: '1px'
    },
    wordWrapTitle: {
        ['@media (max-width: 520px)']: {
            maxWidth: 60,
            wordWrap: 'break-word',
            padding: '10px 0'
        }
    }
});
exports.default = styles;
//# sourceMappingURL=DrawDetailStyle.js.map